import SettingsEmptyState from "../../../../../common/empty-state/SettingsEmptyState";
import RowItems from "./row";

const columns = ["Sl No", "Date", "Template Name", "", "Action"];

const TemplatesTable = ({ handleEditClick, templates, handleconfirmation }) => {
  const isEmpty = !templates?.length;
  return (
    <div className="overflow-y-auto md:h-[75vh] overflow-auto p-0.5">
      <table className="w-full min-w-[600px] lg:min-w-0 border-separate border-spacing-y-1">
        <thead className="border-b sticky top-0">
          <tr className="text-bodyBB text-darkgrey ">
            {columns.map((heading, index) => (
              <th
                key={index}
                className={`sticky -left-10 bg-secondary  border-b-2 h-14 text-darkgrey text-bodySBB  capitalize
            ${index === 0 ? "rounded-tl-15" : ""}
            ${index === columns.length - 1 ? "rounded-tr-15" : ""}
            `}
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!isEmpty && templates.map((data, index) => {
            return (
              <tr
                key={index}
                className="text-center cursor-pointer rounded-15 shadow-card min-h-[50px] mb-2 
            hover:bg-bluishgrey"
              >
                {/* Rows */}
                <RowItems
                  key={index}
                  data={data}
                  index={index}
                  handleconfirmation={handleconfirmation}
                  handleEditClick={handleEditClick}
                />
              </tr>
            );
          })}
        </tbody>
      </table>
      {isEmpty && <SettingsEmptyState />}
    </div>
  );
};

export default TemplatesTable;
